import useSWR from 'swr';
import { sdk } from '@/sdk';
import { Product } from '@shared/types/product';

const useProductSearch = (searchQuery?: string, skus?: string[], limit?: number, storeKey?: string) => {
  // EWM-644 — don't prefetch on empty input. The header mounts this hook 3× (search box,
  // Quick Order, Order-Upload) with empty args on every page; without this guard SWR fired
  // two useless product/query calls per full load, for every user (guests included). Fetch
  // only once there's a real query OR a SKU list to resolve; idle mounts return no results.
  const hasInput = (searchQuery?.trim().length ?? 0) > 0 || (skus?.length ?? 0) > 0;
  const { data, isLoading } = useSWR(hasInput ? ['/action/product/query', searchQuery, skus, limit] : null, () =>
    sdk.composableCommerce.product.query({ query: searchQuery, skus, limit, storeKey }),
  );

  const products = data?.isError ? [] : ((data?.data.items as Product[]) ?? []);

  return { products, isLoading };
};

export default useProductSearch;
